<template>
  <div>
    <div class="tip mb20">
      提示：长按鼠标左键拖动选择排班，多选按住ctrl+鼠标左键，取消选中按住ctrl点击已选中,若无法选择请刷新后重试！
    </div>
    <div class="scheduling-table">
      <div class="theader flex">
        <div class="week"></div>
        <div class="week" v-for="(v, i) in scheduling.xAxis" :key="i">
          {{ v.name }}
        </div>
      </div>
      <div class="tbody flex">
        <div class="taside">
          <div v-for="(v, i) in yAxis" :key="i" class="time">
            {{ v }}
          </div>
        </div>
        <div class="tmain sec">
          <div class="box-wrap boxes red  flex flex-wrap">
            <div
              :data-index="i"
              v-for="(v, i) in eleList"
              class="time"
              :class="{ selected: v.selected, disabled: v.disabled }"
              :key="i"
            ></div>
          </div>
        </div>
      </div>
    </div>
    <div class="select-tip flex">
      <div class="flex item-center mr20">
        <div class="time selected mr20"></div>
        <span class="mr20">已选排班</span>
      </div>
      <div class="flex item-center ">
        <div class="time disabled mr20"></div>
        <span class="mr20">已有排班</span>
      </div>
    </div>
    <!-- <el-button size="small"
               @click="getSelectedList">保存</el-button> -->
  </div>
</template>
<script>
import Selection from "@/utils/selection/selection.js";
export default {
  props: {
    yAxis: {
      type: Array
    }
  },
  data() {
    return {
      eleList: [],
      selection: {},
      scheduling: {
        xAxis: [
          { id: 1, name: "周一" },
          { id: 2, name: "周二" },
          { id: 3, name: "周三" },
          { id: 4, name: "周四" },
          { id: 5, name: "周五" },
          { id: 6, name: "周六" },
          { id: 7, name: "周日" }
        ]
      }
    };
  },
  mounted() {},
  watch: {
    yAxis(val) {
      if (val.length) {
        this.eleList = [];
        const x = this.scheduling.xAxis.length;
        const y = val.length;
        for (let i = 0; i < x * y; i++) {
          this.eleList.push({ selected: false, index: i, disabled: false });
        }
        this.initSelection();
      }
    }
  },
  methods: {
    // 获取class为 selected的元素
    getSelectedEleList() {
      const eleList = Array.from(
        document.querySelectorAll(".box-wrap .selected")
      );
      const list = [];
      const x = this.scheduling.xAxis.length;
      eleList.forEach(v => {
        const index = +v.getAttribute("data-index") + 1;
        // 横坐标
        const abscissa = index % x === 0 ? x - 1 : (index % x) - 1;
        // 纵坐标
        const ordinate =
          index % x === 0 ? Math.floor(index / x) - 1 : Math.floor(index / x);
        list.push({
          week: this.scheduling.xAxis[abscissa].id,
          time: this.yAxis[ordinate],
          index: index - 1
        });
      });
      return list;
    },
    getAllIndex() {
      const list = [];
      const x = this.scheduling.xAxis.length;
      this.eleList.forEach((v, i) => {
        const index = i + 1;
        // 横坐标
        const abscissa = index % x === 0 ? x - 1 : (index % x) - 1;
        // 纵坐标
        const ordinate =
          index % x === 0 ? Math.floor(index / x) - 1 : Math.floor(index / x);
        list.push({
          week: this.scheduling.xAxis[abscissa].id,
          time: this.yAxis[ordinate],
          index: index - 1
        });
      });
      return list;
    },
    cleaarSelected() {
      const eleList = Array.from(
        document.querySelectorAll(".box-wrap .selected")
      );
      eleList.forEach(v => {
        v.classList.remove("selected");
      });
    },
    // getSelectedList() {
    //   const x = this.scheduling.xAxis.length;
    //   // const y = this.scheduling.yAxis.length;
    //   const list = [];
    //   if (this.selection._selectedStore.length) {
    //     this.selection._selectedStore.forEach(v => {
    //       const index = +v.getAttribute("data-index") + 1;
    //       // 横坐标
    //       const abscissa = index % x === 0 ? x - 1 : (index % x) - 1;
    //       // 纵坐标
    //       const ordinate =
    //         index % x === 0 ? Math.floor(index / x) - 1 : Math.floor(index / x);
    //       list.push({
    //         week: this.scheduling.xAxis[abscissa].id,
    //         time: this.scheduling.yAxis[ordinate].time,
    //         index: index - 1
    //       });
    //     });
    //   }
    //   // this.$emit("getSelectedList", list);
    //   return list;
    // },
    initSelection() {
      const that = this;
      this.selection = Selection.create({
        // Class for the selection-area
        class: "selection",

        // All elements in this container can be selected
        selectables: [".box-wrap > div"],

        // The container is also the boundary in this case
        boundaries: [".box-wrap"],
        // 点击时调的方法
        onSelect(evt) {
          // Check if clicked element is already selected
          const selected = evt.target.classList.contains("selected");
          const isDisabled = evt.target.classList.contains("disabled");
          // Remove class if the user isn't pressing the control key or ⌘ key and the
          // current target is already selected
          // 如果不是使用ctrl点击
          if (!evt.originalEvent.ctrlKey && !evt.originalEvent.metaKey) {
            // Remove class from every element that is selected
            that.cleaarSelected();
            evt.selectedElements.forEach(s => s.classList.remove("selected"));
            // Clear previous selection
            this.clearSelection();
          }

          if (!selected && !isDisabled) {
            // Select element
            evt.target.classList.add("selected");
            this.keepSelection();
          } else if (!isDisabled) {
            // Unselect element
            evt.target.classList.remove("selected");
            this.removeFromSelection(evt.target);
          }
        },
        // 开始框选
        onStart({ selectedElements, originalEvent }) {
          // Remove class if the user isn't pressing the control key or ⌘ key
          if (!originalEvent.ctrlKey && !originalEvent.metaKey) {
            // Unselect all elements
            that.cleaarSelected();
            selectedElements.forEach(s => s.classList.remove("selected"));

            // Clear previous selection
            this.clearSelection();
          }
        },
        // 框选移动
        onMove({ selectedElements, changedElements }) {
          // Add a custom class to the elements that where selected.
          selectedElements.forEach(s => {
            if (!s.classList.contains("disabled")) {
              s.classList.add("selected");
            }
          });

          // Remove the class from elements that where removed
          // since the last selection
          changedElements.removed.forEach(s => s.classList.remove("selected"));
        },
        // 结束框选
        onStop() {
          this.keepSelection();
        },
        selectionFilter(evt) {
          evt.selection; // This selection instance
          evt.eventName; // The event name
          evt.element; // The element which is in the current selection
          // return true to keep the element in the current selection
        }
      });
    }
  }
};
</script>

<style scoped lang="scss">
// $borderColor: #f5f7fa;
$borderColor: #f5f7fa;
.select-tip {
  margin: 10px 0;
  .time {
    width: 80px;
    height: 24px;
    line-height: 24px;
  }
  .selected {
    background: #e50163;
    opacity: 0.2;
  }
  .disabled {
    background: #ddd;
    opacity: 0.5;
  }
}
.scheduling-table {
  width: 640px;
  border-top: 1px solid $borderColor;
  border-left: 1px solid $borderColor;
  border-bottom: 1px solid $borderColor;
  .week,
  .time {
    width: 80px;
    height: 24px;
    line-height: 24px;
    text-align: center;
    font-size: 14px;
    box-sizing: border-box;
    transition: all 0.3s;
  }

  .taside,
  .theader {
    user-select: none;
  }
  .theader {
    background: $borderColor;
    border: 1px solid $borderColor;
  }

  /* details */
  .boxes.red div.selected {
    background: #e50163;
    opacity: 0.2;
  }
  .taside {
    .time:first-child {
      // border-top: 1px solid $borderColor;
      margin-top: 1px;
    }
    .time:last-child {
      border-bottom: none;
    }
    .time {
      border-bottom: 1px solid $borderColor;
      border-right: 1px solid $borderColor;
    }
  }
  .tmain {
    .time {
      cursor: pointer;
      border-right: 1px solid $borderColor;
      border-top: 1px solid $borderColor;
    }
  }

  .time.disabled {
    background: #ddd;
    opacity: 0.5;
  }
}
.btn-wrapper {
  margin-top: 20px;
}
</style>
